import { AxiosInstance } from "axios";
import { ICustomAxiosError } from "./types";

export const retryAxiosRequest = (
  error: ICustomAxiosError,
  axios: AxiosInstance
) => {
  const { config, response } = error;
  const { url } = config;

  console.error(
    [
      "API RESPONSE ERROR:",
      JSON.stringify({
        url,
        status: response?.status,
        responseData: response?.data,
        responseHeaders: response?.headers,
        requestBody: config?.data,
        requestHeaders: config?.headers,
      }),
    ].join(" | ")
  );

  if ((response?.status && response.status < 400) || !config || !config.retry) {
    return Promise.reject(error);
  }

  //decrease retry count by 1
  config.retry -= 1;

  // Return Promise to retry the request
  return axios.request(config);
};
